import Tooltip from "@mui/material/Tooltip";
import { MenuItem } from "@mui/material";
import { Delete } from "@mui/icons-material";
import React, { useState } from "react";
import { useApiClient } from "../../../api";
import { enqueueSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import AreYouSureDialog from "../../../shared-components/AreYouSureDialog";

export const AssignmentDeleteMenuItem = ({
  assignmentId,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const ApiClient = useApiClient();
  const navigate = useNavigate();

  const deleteAssignment = async () => {
    try {
      const response = await ApiClient.assignment.deleteAssignment({
        assignment: assignmentId,
      });
      if (response.success) {
        setOpen(false);
        enqueueSnackbar("Deleted assignment", {
          variant: "success",
          autoHideDuration: 3000,
        });
        navigate(-1); // go back one step in history - is this right?
      } else {
        enqueueSnackbar("Failed to delete assignment", {
          variant: "error",
          autoHideDuration: 3000,
        });
      }
    } catch (error) {
      console.error("Failed to update evidence", error);
      enqueueSnackbar("Failed to delete assignment", {
        variant: "error",
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <>
      <AreYouSureDialog
        open={open}
        actionText={"you want to delete this assignment"}
        setOpen={setOpen}
        onDelete={deleteAssignment}
        title={"Delete Assignment"}
      />
      <Tooltip
        title={disabled ? "Can only delete assignments without answers" : ""}
      >
        <span>
          <MenuItem
            disabled={disabled}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            <Delete fontSize="small" sx={{ mr: 1 }} />
            Delete
          </MenuItem>
        </span>
      </Tooltip>
    </>
  );
};
